import { useCallback } from "react";
import { PlatformApi, AppConstants } from "../../configs";
import { useAppSelector, AxiosAuth } from "../../core";
import { ApiResponse } from "../../models";
import { RoomShareMapModel } from "../../models/api/Call";

export function useFunctionalityRoomShareMap() {

  const LoadRoomMap = useCallback(async (guidGenerated: string) => {
    const sessionMapsUrl = PlatformApi.GetRoomShareMap.GetRoomMap(guidGenerated);
    try {
      const res = await AxiosAuth.get<RoomShareMapModel>(sessionMapsUrl);

      if (res.status === AppConstants.Api.StatusOK && res.data) {
        
        return res.data; 
      } else {
        return null; 
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);

  return {
    LoadRoomMap,
  };
}
